import async from 'async'
import _ from 'lodash'

import app from '../app.jsx'
import Calculate from './calculate.jsx'
import currency from './currency.jsx'

let _phaseState = {}

function _createEmptyBudget () {
  return { phases: [] }
}

function _clearPhaseState () {
  return (_phaseState = {})
}

function _setPhaseState (state) {
  _phaseState = state
}

function _getPhaseState () {
  return _phaseState
}

function _savePhaseState (phaseIdx, bExpand) {
  _phaseState[phaseIdx] = bExpand
}

function _deletePhaseFromState (phaseIdx) {
  const newState = {}

  // It will remove the phaseIdx and rearrange other phases
  let idx = -1
  for (const key of Object.keys(_phaseState)) {
    if (key !== phaseIdx) {
      idx++
      newState[idx] = _phaseState[key]
    }
  }

  _phaseState = newState
}

function _getPhaseStateFromId (phaseIdx) {
  return _phaseState[phaseIdx] !== undefined ? _phaseState[phaseIdx] : true
}

function _getRenderObject (budgetObj, items) {
  const budget = _.cloneDeep(budgetObj)
  budget.lastActivityId = 1
  budget.lastPhaseId = 1

  budget.phases.map((phase, phaseId) => {
    _getRenderPhaseObject(budget, phase, phaseId, items)
  })

  return budget
}

function _getRenderPhaseObject (budget, phase, phaseId, items) {
  phase.id = phaseId
  phase.dragId = budget.lastPhaseId++
  phase.dragItemType = 'phase'
  phase.editable = false
  phase.expanded = _getPhaseStateFromId(phaseId)
  phase.bTitleCompleted = true
  phase.percentage = 0
  phase.spentAmount = 0
  phase.overSpent = 0
  phase.showAdd = false

  const groups = []
  _.cloneDeep(items).map((item, _itemIdx) => {
    if (item.phaseNo === phaseId + 1) {
      const itemObj = _.cloneDeep(item)
      const groupIdx = item.groupNo - 1

      if (groups[groupIdx] === undefined) {
        groups[groupIdx] = {
          id: groupIdx,
          items: []
        }
      }

      delete item.phaseNo
      delete item.groupNo
      delete item.orderNo

      itemObj.dragId = budget.lastActivityId++
      itemObj.dragItemType = 'item'
      itemObj.phaseId = phaseId
      itemObj.groupId = groupIdx
      itemObj.editable = false
      itemObj.bTitleCompleted = true
      itemObj.expenseCount = itemObj.expenseCount || 0
      itemObj.poCount = itemObj.poCount || 0

      if (itemObj.purchaseOrders) {
        itemObj.purchaseOrders.map(ord => {
          ord.contact = ord.contact ? ord.contact : { title: '' }
          ord.purchaseOrder = ord.purchaseOrder
            ? ord.purchaseOrder
            : { orderNo: '' }
        })
      }

      if (itemObj.spentAmount) {
        phase.spentAmount += itemObj.spentAmount
      }

      if (itemObj.overSpent) {
        phase.overSpent += itemObj.overSpent
      }

      groups[groupIdx].items.push(itemObj)
    }
  })

  phase.percentage = Calculate.percentage(phase.spentAmount, phase.total)

  // If the last groups last item is subtotal - then add empty new group
  if (groups.length > 0) {
    const lastGroupIdx = groups.length - 1
    const lastGroup = groups[lastGroupIdx]

    if (lastGroup.items.length > 0) {
      const lastItemIdx = lastGroup.items.length - 1
      const lastItem = lastGroup.items[lastItemIdx]

      if (lastItem.type === 'subtotal') {
        const newGroup = { id: groups.length, items: [] }
        groups.push(newGroup)
      }
    }
  } else {
    // Empty group for dropping items
    const newGroup = { id: groups.length, items: [] }
    groups.push(newGroup)
  }

  phase.groups = groups

  return phase
}

function _getSaveObject (budgetObj, bEstimate) {
  const items = []
  const budget = _.cloneDeep(budgetObj)

  delete budget.lastActivityId
  delete budget.lastPhaseId

  budget.phases.map((phase, phaseIdx) => {
    const groups = phase.groups
    _savePhaseState(phaseIdx, phase.expanded)

    delete phase.id
    delete phase.dragId
    delete phase.dragItemType
    delete phase.orgIndex
    delete phase.editable
    delete phase.expanded
    delete phase.bTitleCompleted
    delete phase.bEdit
    delete phase.groups
    delete phase.overSpent
    delete phase.showAdd

    phase.fromDate = phase.fromDate ? phase.fromDate : null
    phase.toDate = phase.toDate ? phase.toDate : null

    groups.map((group, groupIdx) => {
      _.remove(group.items, obj => obj.isEmptyDragItem) // || obj.type === 'subtotal'));

      group.items.map((item, itemIdx) => {
        const itemObj = _createSaveItemObject(_.cloneDeep(item), bEstimate)

        itemObj.phaseNo = phaseIdx + 1
        itemObj.groupNo = groupIdx + 1
        itemObj.orderNo = itemIdx + 1
        itemObj.fromDate = itemObj.fromDate ? itemObj.fromDate : null
        itemObj.toDate = itemObj.toDate ? itemObj.toDate : null

        items.push(itemObj)
      })
    })
  })

  return { budget, items }
}

function _getNewItemObject (item, bEstimate) {
  const phaseId = item.phaseId
  const groupId = item.groupId
  // const itemId = item.dragId;
  const itemObj = _createSaveItemObject(_.cloneDeep(item), bEstimate)

  itemObj.phaseNo = phaseId + 1
  itemObj.groupNo = groupId + 1
  // itemObj.orderNo = itemId + 1;

  return itemObj
}

function _createSaveItemObject (itemObj, bEstimate) {
  delete itemObj.dragId
  delete itemObj.dragItemType
  delete itemObj.phaseId
  delete itemObj.groupId
  delete itemObj.orgPhaseId
  delete itemObj.orgGroupId
  delete itemObj.orgIndex
  delete itemObj.editable
  delete itemObj.bTitleCompleted
  delete itemObj.bEdit
  delete itemObj.purchaseOrders
  delete itemObj.contact
  delete itemObj.bUsed
  delete itemObj.bUpdateTotal
  delete itemObj.bUpdateSpentAmount
  delete itemObj.bSaveItem
  delete itemObj.overSpent
  delete itemObj.showAdd
  delete itemObj.expenseCount
  delete itemObj.poCount

  if (!bEstimate) {
    delete itemObj.vat
  } else {
    delete itemObj.initialBudget
    delete itemObj.markupPercentage
  }

  return itemObj
}

function _getUpdateItemObject (itemObj, attrs) {
  attrs = Array.isArray(attrs) ? attrs : [attrs]

  const updateObj = {}
  attrs.map(attribute => {
    updateObj[attribute] = itemObj[attribute]
  })

  return updateObj
}

function _createNewActivity (
  budget,
  type,
  phase,
  groupId,
  bEstimate,
  vat,
  markupPercentage,
  rate
) {
  const createObj = {
    id: null,
    dragId: budget.lastActivityId++,
    dragItemType: 'item',
    type: type,
    title: '',
    description: '',
    total: 0,
    percentage: '',
    spentAmount: 0,
    noHours: '',
    pricePerHour: rate || 0,
    fromDate:
      phase.fromDate && phase.fromDate !== undefined ? phase.fromDate : null,
    toDate: phase.toDate && phase.toDate !== undefined ? phase.toDate : null,
    editable: 'title',
    bTitleCompleted: false,
    phaseId: phase.id,
    groupId: groupId,
    bUseTotal: false,
    overSpent: 0,
    showAdd: false,
    expenseCount: 0,
    poCount: 0,
    labelType: ''
  }

  if (bEstimate) {
    createObj.summary = ''
    createObj.vat = vat
    createObj.labelType = ''
  } else {
    createObj.initialBudget = -1
    createObj.markupPercentage = markupPercentage
  }

  return createObj
}

function _forEachPurchaseOrder (budgetObj, callback) {
  for (const phase of budgetObj.phases) {
    if (phase.groups && phase.groups.length > 0) {
      for (const group of phase.groups) {
        for (const item of group.items) {
          if (item.purchaseOrders) {
            for (const order of item.purchaseOrders) {
              callback(order)
            }
          }
        }
      }
    }
  }
}

function _onSearchSupplier (keyword, excludeIds, callback, bListAll = false) {
  if (keyword || bListAll) {
    const params = {
      query: {
        $select: ['_id', 'company'],
        $limit: 20,
        archived: false
      }
    }

    // If we have only keyword, then filter using keyword
    if (!bListAll) {
      const pattern = keyword
        .replace(/[-/\\^$*+?.()|[\]{}]/g, '\\$&')
        .replace(/\$/g, '$$$$')
      params.query.company = { $regex: pattern, $options: 'i' }
    }

    if (excludeIds && excludeIds.length > 0) {
      params.query._id = { $nin: excludeIds }
    }

    app
      .service('/api/contact')
      .find(params)
      .then(result => {
        let supplierList = []

        if (result.data) {
          supplierList = result.data.map((obj, _idx) => {
            return {
              supplierId: null,
              contactId: obj.id,
              supplierName: obj.company,
              purchaseOrderId: null,
              poNumber: '',
              totalPoAmount: 0,
              expenseBookedOnPo: 0,
              remaingPoAmount: 0,
              expenses: []
            }
          })
        }

        callback(supplierList)
      })
      .catch(err => {
        app.debug('Budget content: getDataSupplier err', err)
        callback([]) // eslint-disable-line standard/no-callback-literal
      })
  } else {
    callback([]) // eslint-disable-line standard/no-callback-literal
  }
}

function _getDataPurchaseOrdersDetails (budget, items, callback) {
  if (budget) {
    const contactIds = []
    const purchaseOrderIds = []
    const contactMap = {}
    const purchaseOrderMap = {}
    let itemSuppliers = []
    const expenseItemMap = {}
    const itemIds = items.map(item => item.id)

    async.series(
      [
        done => {
          if (itemIds.length > 0) {
            const params = { query: { budgetItemId: itemIds } }
            app
              .service('/api/project/budgetitemsupplier')
              .find(params)
              .then(result => {
                itemSuppliers = result.data
                result.data.map(itemSupplier => {
                  contactIds.push(itemSupplier.contactId)
                  if (itemSupplier.purchaseOrderId) {
                    purchaseOrderIds.push(itemSupplier.purchaseOrderId)
                  }
                })

                done(null)
              })
              .catch(_err => {
                done(null)
              })
          } else {
            done(null)
          }
        },
        done => {
          if (contactIds.length > 0) {
            const params = {
              query: {
                _id: contactIds,
                $select: ['_id', 'company']
              }
            }

            app
              .service('/api/contact')
              .find(params)
              .then(result => {
                result.data.map(obj => {
                  contactMap[obj.id] = obj
                })

                done(null)
              })
              .catch(err => {
                app.debug('Budget content: _getDataPurchaseOrders err', err)
                done(null)
              })
          } else {
            done(null)
          }
        },
        done => {
          if (purchaseOrderIds.length > 0) {
            const params = {
              query: {
                _id: purchaseOrderIds,
                $select: ['_id', 'invoiceNo']
              }
            }

            app
              .service('/api/purchaseorder')
              .find(params)
              .then(result => {
                result.data.map(obj => {
                  purchaseOrderMap[obj.id] = obj
                })

                done(null)
              })
              .catch(err => {
                app.debug('Budget content: _getDataPurchaseOrders err', err)
                done(null)
              })
          } else {
            done(null)
          }
        },
        done => {
          const itemSupplierIds = itemSuppliers.map(
            itemSupplier => itemSupplier.id
          )
          if (
            itemSupplierIds &&
            itemSupplierIds.length > 0 &&
            itemIds &&
            itemIds.length > 0
          ) {
            const params = {
              query: {
                budgetItemSupplierId: itemSupplierIds,
                budgetItemId: itemIds
              }
            }

            app
              .service('/api/expense/item')
              .find(params)
              .then(expItemRes => {
                if (expItemRes && expItemRes.total > 0) {
                  expItemRes.data.map(expItem => {
                    expenseItemMap[expItem.budgetItemSupplierId] = true
                  })
                }
                done(null)
              })
              .catch(expItemErr => {
                done(expItemErr)
              })
          } else {
            done(null)
          }
        },
        done => {
          itemSuppliers.map(itemSupplier => {
            if (itemSupplier.contactId && contactMap[itemSupplier.contactId]) {
              const contact = contactMap[itemSupplier.contactId]
              itemSupplier.contact = { id: contact.id, title: contact.company }
            } else {
              itemSupplier.contact = { id: null, title: '' }
            }

            if (
              itemSupplier.purchaseOrderId &&
              purchaseOrderMap[itemSupplier.purchaseOrderId]
            ) {
              itemSupplier.purchaseOrder =
                purchaseOrderMap[itemSupplier.purchaseOrderId]
            }

            itemSupplier.bHasExpense = false
            if (expenseItemMap[itemSupplier.id]) {
              itemSupplier.bHasExpense = true
            }

            const itemObj = _.find(
              items,
              obj => obj.id === itemSupplier.budgetItemId
            )
            if (itemObj) {
              if (!itemObj.purchaseOrders) itemObj.purchaseOrders = []

              itemObj.purchaseOrders.push(itemSupplier)
            }
          })

          done(null)
        }
      ],
      (err, _res) => {
        callback(err)
      }
    )
  } else {
    callback(null)
  }
}

function _calculateSpentAmount (item, callback) {
  if (!item.id) {
    callback(null)
    return
  }

  if (item.type === 'expense-activity') {
    item.percentage = Calculate.percentage(item.spentAmount, item.total)

    callback(null)
    return
  }

  if (item.type === 'time-activity') {
    // If normal type
    if (!item.bUseTotal) {
      item.spentAmount = item.timeSpent
        ? item.pricePerHour * (item.timeSpent / 60)
        : 0
      item.percentage = Calculate.percentage(item.spentAmount, item.total)

      callback(null)
      return
    }

    const calculateData = {
      projectId: item.projectId,
      budgetItemId: item.id,
      budgetItemTotal: item.total
    }

    app
      .service('/api/project/calculatespent')
      .create(calculateData)
      .then(result => {
        item.spentAmount = result.spentAmount
        item.percentage = result.percentage
        callback(null)
      })
      .catch(err => {
        app.debug('Budget content: _calculateSpentAmount err', err)
        callback(null)
      })
  }
}

function _calculateSellingPrice (budgetTotal, markupPercentage) {
  budgetTotal = parseFloat(budgetTotal) || 0
  markupPercentage = parseFloat(markupPercentage) || 0

  if (!markupPercentage) {
    return budgetTotal
  }

  return currency.round(budgetTotal * (1 + markupPercentage / 100))
}

function _calculateMarkupPercentage (budgetTotal, sellingPrice) {
  budgetTotal = parseFloat(budgetTotal) || 0
  sellingPrice = parseFloat(sellingPrice) || 0

  if (!budgetTotal) {
    return 0
  }

  return currency.round(100 * (sellingPrice / budgetTotal - 1))
}

const BudgetUtil = {}
BudgetUtil.createEmptyBudget = _createEmptyBudget
BudgetUtil.getSaveObject = _getSaveObject
BudgetUtil.getRenderObject = _getRenderObject
BudgetUtil.getRenderPhaseObject = _getRenderPhaseObject
BudgetUtil.forEachPurchaseOrder = _forEachPurchaseOrder
BudgetUtil.onSearchSupplier = _onSearchSupplier
BudgetUtil.getDataPurchaseOrdersDetails = _getDataPurchaseOrdersDetails
BudgetUtil.getNewItemObject = _getNewItemObject
BudgetUtil.getUpdateItemObject = _getUpdateItemObject
BudgetUtil.createNewActivity = _createNewActivity
BudgetUtil.clearPhaseState = _clearPhaseState
BudgetUtil.setPhaseState = _setPhaseState
BudgetUtil.getPhaseState = _getPhaseState
BudgetUtil.deletePhaseFromState = _deletePhaseFromState
BudgetUtil.calculateSpentAmount = _calculateSpentAmount
BudgetUtil.calculateSellingPrice = _calculateSellingPrice
BudgetUtil.calculateMarkupPercentage = _calculateMarkupPercentage

export default BudgetUtil
